// extracted by mini-css-extract-plugin
module.exports = {"heading":"Search_heading__3jhFe","searchBox":"Search_searchBox__32f_H","hr":"Search_hr__jKTeO","result":"Search_result__3rPKm","minSearchHeight":"Search_minSearchHeight__13w10"};